
import ServicesList from './services/ServicesList';

const ServicesSection = () => {
  return (
    <section id="services" className="py-8 sm:py-12 md:py-16 bg-[#333333]">
      <div className="container mx-auto px-2 sm:px-4">
        <h2 className="text-2xl sm:text-3xl font-bold mb-8 sm:mb-12 text-center text-accent hover:text-accent-hover transition-colors">
          Our Services
        </h2>
        <ServicesList />
      </div>
    </section>
  );
};

export default ServicesSection;
